const UpgradeVersionComponentType = {
  link: "link",
  button: "button",
  indicator: "indicator",
};

export { UpgradeVersionComponentType };
